import React from "react";
import { TextMessage } from "@lango/api/src/queries/chat/types";
import { Button } from "@/components/common/Button";
import { MagicIcon } from "@/components/common/icons/MagicIcon";

import styles from "./UserTextMessage.module.css";

type Props = {
  data: TextMessage;
  onPlayText?: (text: string) => void;
  onGrammarReview?: () => void;
};

export const UserTextMessage: React.FC<Props> = ({ data, onGrammarReview }) => {
  const text = data.text;

  return (
    <div className={styles.container}>
      <div className={styles.bubble}>
        <div className={styles.messageText}>{text}</div>
        <div className={styles.actionButtonWrap}>
          {onGrammarReview && (
            <Button
              variant={"clean"}
              className={styles.grammar}
              onClick={onGrammarReview}
            >
              <MagicIcon className={styles.icon} />
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
